import api from "../../../axiosConfig";

export const emailTemplatesApi = {
  list: async () => {
    const res = await api.get("/email/templates");
    return res.data;
  },

  get: async (id) => {
    const res = await api.get(`/email/templates/${id}`);
    return res.data;
  },

  create: async ({ name, subject, body_html }) => {
    const res = await api.post("/email/templates", { name, subject, body_html });
    return res.data;
  },

  update: async (id, { name, subject, body_html }) => {
    const res = await api.put(`/email/templates/${id}`, { name, subject, body_html });
    return res.data;
  },

  delete: async (id) => {
    await api.delete(`/email/templates/${id}`);
  },
};
